import React from 'react';

const ImagenHeroUno = () => {
  return(
    <>
      <img className='hero-comida-principal' src="/Imagenes/Hero/Hero-Principal.png" alt="Ensalada" loading="lazy" />
    </>
  )
}

export { ImagenHeroUno }